export default class KeyboardKeysService {
  constructor($document, $timeout) {
    'ngInject';
    this.default = $document;
    this.$timeout = $timeout;
  }

  /**
   * set keyup and keydown on an element, default will be document
   * @param {*}onCtrlS : ctrl+S callback
   * @param onCtrlZ : ctrl+V callback
   */
  set({ elem = null, onCtrlS, onCtrlZ }) {
    this.element = elem || this.default;
    this.onCtrlS = onCtrlS;
    this.onCtrlZ = onCtrlZ;
    this.element.bind('keydown', this.onKeyDown.bind(this));
  }

  /**
   * clear the events
   */
  unSet() {
    this.onCtrlS = undefined;
    this.onCtrlZ = undefined;
    this.element.unbind('keydown');
    this.element = undefined;
  }

  onKeyDown(event) {
    if (this.onCtrlS) {
      const { key = '', keyCode } = event;
      const is_SKey = key.toLowerCase() === 's' || keyCode === 83;
      const is_ZKey = key.toLowerCase() === 'z' || keyCode === 90;

      if (event.ctrlKey) {
        if (is_SKey) {
          event.preventDefault();
          this.onCtrlS();
        } else if (is_ZKey) {
          event.preventDefault();
          this.$timeout(() => this.onCtrlZ());
        }
      }
      if (is_SKey && this.ctrlDown) {
        event.preventDefault();
        this.onCtrlS();
      }
    }
  }
}
